import React, {Component, Fragment} from 'react';
import { Link, Redirect } from 'react-router-dom';
import {cardContentStyle, cardHeaderStyle, cardStyle, cardTitleStyle} from "../SsoLink/styles/SsoLink.css";
import SsoLinkForm from "./SsoLinkForm";
import {cardFooterStyle, errorStyle, linkStyle} from "./styles/SsoLink.css";
import {connect} from "react-redux";
import {apiLinkUser} from "../../api";
import {formatExternalUrl} from '../../functions/FormatUrl';
import Button from '../common/Button';

export class SsoLink extends Component {

  handleSubmitClick = e => {
    e.preventDefault();
    let userData = {
      emailAddress: this.props.formData.values.email,
      password: this.props.formData.values.password,
      firstName: this.props.query.f,
      lastName: this.props.query.l,
      appId: this.props.tokenData.appId,
      clientId: this.props.tokenData.clientId,
      userId: this.props.tokenData.userId,
      officeId: this.props.tokenData.officeId,
      userGuid: this.props.tokenData.userGuid,
      officeGuid: this.props.tokenData.officeGuid
    }

    this.props.requestLinkUser(this.props.query.t, userData, this.props.query.c);
  };

  handelRedirect = e => {
    e.preventDefault();
    window.location.href = this.props.query.r;
  }

  render(){

    const redirect =
      this.props.redirectUrl ? <Redirect to={this.props.redirectUrl + this.props.match.params.passedInfo} push/> : null;

    const errorMessage = () => {
      if(this.props.responseError && this.props.responseError.status) {
        if (this.props.responseError.status === 404  && this.props.responseError.message === "Could not locate user") {
          return <label style={errorStyle}>Your account or password was entered incorrectly.</label>;
        } else if (this.props.responseError.status === 409) {
          return ( <label style={errorStyle}>
            This Lone Wolf Account email is already linked to this{' '}
            {this.props.tokenData.appName} account.{' '}
            <br/>
            <a href={formatExternalUrl(this.props.query.r)}>
              Please log in to {this.props.tokenData.appName}
            </a>{' '}
            using your Lone Wolf Account email.
          </label>)
        } else {
          return <label style={errorStyle}>Unknown error.</label>;
        }
      }
      else
        return ''
    };

    return(
      <Fragment>
        <div className="container content">
          {redirect}
          <br/>
          <div className="card" style={cardStyle}>
            <div className="card-body">
              <div style={cardHeaderStyle}>
                <div className="card-title" style={cardTitleStyle}>
                  Link Lone Wolf Account
                </div>
                <div>
                  Please enter your Lone Wolf Account email and password to link it to
                  your {this.props.tokenData.appName} account. (This is the same email you use to log into Back Office.)
                </div>
                <div>
                  Once linked, please begin using your Lone Wolf Account email to log in to {this.props.tokenData.appName}.
                </div>
                <div style={cardContentStyle}>
                  <SsoLinkForm apiError={errorMessage()} handleSubmit={this.handleSubmitClick} />
                </div>
                <hr/>
                <div style={cardFooterStyle}>
                  <span>
                    Don't have an Lone Wolf Account?{' '}
                    <Link
                      to={
                        '/register/sso-create/' +
                        this.props.match.params.passedInfo
                      }
                      style={linkStyle}
                    >
                      Create Account
                    </Link>
                  </span>
                </div>
                <div className="row justify-content-center text-center">
                  <Button
                    action={this.handelRedirect}
                    text={'Skip for Now'}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  query: state.initial.queryInfo,
  tokenData: state.initial.tokenData,
  formData: state.form.SsoLink,
  responseStatus: state.linkReducer.auth,
  responseError: state.linkReducer.err,
  redirectUrl: state.linkReducer.nextPage,
});

const mapDispatchToProps = dispatch => ({
  requestLinkUser: (token, request, appCallback) =>
    dispatch(apiLinkUser(token, request, appCallback))
});


export default connect(mapStateToProps, mapDispatchToProps)(SsoLink);
